module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS1.7aa26898.jpg";